import _kebabCase from "lodash/kebabCase";
import _isArray from "lodash/isArray";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.array.map.js";
import React, { Fragment } from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { Li, List, Type } from '@nerdwallet/currency';
import { If } from './control-statements';
import { sanitizeNode } from './lib/utils';
var BaseOptionalListContent = function BaseOptionalListContent(_ref) {
  var className = _ref.className,
    content = _ref.content,
    contentLabel = _ref.contentLabel;
  return /*#__PURE__*/React.createElement(Fragment, null, !_isEmpty(content) ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, contentLabel), content) : null);
};
var OptionalListContent = function OptionalListContent(_ref2) {
  var className = _ref2.className,
    content = _ref2.content,
    contentLabel = _ref2.contentLabel,
    _ref2$useLiPadding = _ref2.useLiPadding,
    useLiPadding = _ref2$useLiPadding === void 0 ? false : _ref2$useLiPadding;
  return /*#__PURE__*/React.createElement(BaseOptionalListContent, {
    className: className,
    content: _isArray(content) ? /*#__PURE__*/React.createElement(List, null, content.map(function (listBullet) {
      var _listBullet$id, _listBullet$bullet;
      return /*#__PURE__*/React.createElement(Li, {
        key: "bullet-".concat(_kebabCase((_listBullet$id = listBullet === null || listBullet === void 0 ? void 0 : listBullet.id) !== null && _listBullet$id !== void 0 ? _listBullet$id : listBullet)),
        className: classes({
          'margin-bottom-2': useLiPadding
        })
      }, sanitizeNode((_listBullet$bullet = listBullet === null || listBullet === void 0 ? void 0 : listBullet.bullet) !== null && _listBullet$bullet !== void 0 ? _listBullet$bullet : listBullet));
    })) : sanitizeNode(content),
    contentLabel: contentLabel
  });
};
export default OptionalListContent;